<template>
    <div class="card-body">
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text">WMS</span>
            </div>
            <input type="text" class="form-control" v-model="urlServicio" placeholder="Escribe la URL del servicio" />
            <div class="input-group-append">
                <button class="btn btn-primary" @click="addService">Agregar</button>
            </div>
        </div>
        <ul class="lista-servicios">
            <li v-for="(service, index) in services" :key="index">
                <i class="fa fa-times pointer" @click="removeService(index)"></i>
                {{ service.url }}
            </li>
        </ul>
    </div>
</template>

<script>
    import { loadModules } from 'esri-loader';
    import { arcgisConfig } from '@/config';

    const arcgisModules = loadModules([
        'esri/layers/WMSLayer',
    ], arcgisConfig.loaderOptions);

    export default {
        name: "WMSServices",
        props: ['map'],
        data(){
            return{
                services: [],
                urlServicio: '',
                lastError: '',
            }
        },
        methods: {
            async addService() {
                if (this.urlServicio.trim().length === 0) {
                    return
                }

                const [WMSLayer] = await arcgisModules;
                try {
                    const urlServicio = this.urlServicio;
                    this.urlServicio = '';
                    const layer = new WMSLayer({
                        url: urlServicio,
                    });

                    const errTimeout = setTimeout( () => {
                        alert('No se pudo agregar el servicio' + urlServicio );
                    },3000);

                    this.map.add(layer);
                    layer.on("layerview-create", event => {
                        clearInterval(errTimeout);
                        this.services.push({
                            url: urlServicio,
                            layer: layer,
                        });
                    });

                }catch (e) {
                    this.lastError = e.toString();
                }

            },
            removeService(index){
                this.map.remove(this.services[index].layer);
                this.services.splice(index, 1);
            }
        }
    }
</script>

<style scoped>

</style>
